<template>
    <Modal v-model="openModal" modalClass="modal-dialog message-modal modal-lg ">
        <template v-slot:titlebar>
            <div class="d-none"></div>
        </template>
        <template v-slot:content>
            <div class="modal-content px-2 px-md-4">

                <div class="modal-body staff my-1 overflow-y-auto d-flex flex-column h-100">
                    <div class="message-header bg-white " >
                        <div class="d-flex">
                            <div class="w-100 conversation-select" v-if="!member">
                                <StaffSelect @change="memberSelected($event)"></StaffSelect>
                            </div>
                            <div v-if="member" class="d-flex align-items-center gap-3">
                                <basic-button
                                    @click="member = null"
                                    icon="fi-rr-arrow-left"
                                    class="btn-sm btn-outline btn-circle"/>

                                <div>
                                    <div class="title large mb-0" v-if="member.id !== senderId">
                                        {{ member.name }}  {{ member.surname }}
                                    </div>
                                    <div class="title large mb-0" v-if="member.id === senderId">
                                        {{trans('general.page.messages.notes')}}
                                    </div>
                                    <p class="text-gray-700 mb-0">{{ member.roles.map(v => trans(`general.module.role.${v.name}`)    ).join(', ') }}</p>
                                </div>
                            </div>

                            <button type="button" @click.prevent="openModal = false" class="btn-close ms-auto mt-2"></button>
                        </div>
                    </div>

                    <Conversation v-if="receiverId" :roles="roles" :user-id="senderId"
                                  v-on:users-changed="participants = $event"
                                  :sender-id="(selectedSenderId || senderId)" :receiver-id="receiverId" :messageSent="newMessage">
                    </Conversation>

                    <MessageForm v-if="receiverId"
                        v-on:message-sent="newMessage = $event" :user-id="senderId" :users="participants"
                        :sender-id="(selectedSenderId || senderId)" :receiver-id="receiverId" :roles="roles" >
                    </MessageForm>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import StaffSelect from "../atoms/StaffSelect";
import VueModal from "@kouts/vue-modal";
import Conversation from "../molecules/Conversation";
import RoleService from "../../../services/RoleService";
import MessageForm from "../molecules/MessageForm";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "StaffMessageModal",
    props: {
        senderId: Number,
        selected: Object,
        roles: Array
    },
    components: {
        StaffSelect,
        Conversation,
        MessageForm,
        'Modal': VueModal,
        BasicButton,

    },
    data() {
        return {
            openModal: false,
            member: null,
            receiverId: null,
            roleService: RoleService,
            selectedSenderId: null,
            newMessage: null,
            participants: null,
        }
    },
    watch: {
        openModal: function (val) {
            if (!val) {
                let sender = (this.selectedSenderId || this.senderId );
                Echo.leave(`App.Models.Staff.${sender + this.receiverId}`);
                this.$emit('messages-closed', true)
            }
        },
        member: function (val) {
            this.receiverId = val ? val.id : null;
        }
    },
    methods: {
        open(member) {
            this.member = member || null
            this.openModal = true;
        },
        close() {
            this.openModal = false;
        },
        memberSelected(event) {
            this.member = event;
        }
    },
    mounted() {
        this.member = this.selected;
    }
}
</script>

<style>
.conversation-select {
  min-height: 430px;
}

.vm {
    top: 30px !important;
}
</style>
